const health = [
    {
        "source": {
            "id": null,
            "name": "CNET"
        },
        "author": null,
        "title": "12 Best Probiotic Foods to Eat for Gut Health - CNET",
        "description": "Dealing with gut issues? Support your digestive health with these foods that are high in probiotics.",
        "url": "https://www.cnet.com/health/nutrition/12-best-probiotic-foods-to-eat-for-your-gut-health/",
        "urlToImage": "https://www.cnet.com/a/img/resize/904fc5a72976c080e3273c59327f4b899d14348b/hub/2023/02/03/c944d9d7-f0dd-438a-9f91-fd1a154567e4/gettyimages-1279140719.jpg?auto=webp&fit=crop&height=675&width=1200",
        "publishedAt": "2023-09-24T14:00:00Z",
        "content": "You've probably heard of probiotics and how essential they are for a healthy gut and overall well-being. These living microorganisms can help promote the growth of good bacteria in your gut, and you … [+6359 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Monash.edu"
        },
        "author": "Tamara May",
        "title": "How hormones and the menstrual cycle can affect women with ADHD - Monash Lens",
        "description": "<p>Have you noticed your levels of attention may slightly change during your menstrual cycle?</p> <p>This may be particularly noticeable for women and people assigned female at birth with attention deficit hyperactivity disorder (ADHD). They have differences …",
        "url": "https://lens.monash.edu/@medicine-health/2023/09/24/1386049/how-hormones-and-the-menstrual-cycle-can-affect-women-with-adhd-5-common-questions",
        "urlToImage": "https://res.cloudinary.com/cognitives-s3/image/upload/c_fill,dpr_auto,f_auto,fl_lossy,h_800,q_auto,w_1200/v1/cog-live/n/1271/2023/Aug/22/Nb6MvoZTnRYz482xUaMP.jpg",
        "publishedAt": "2023-09-24T13:59:15Z",
        "content": "Have you noticed your levels of attention may slightly change during your menstrual cycle?\r\nThis may be particularly noticeable for women and people assigned female at birth with attention deficit hy… [+6342 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Siasat Daily"
        },
        "author": "Indo-Asian News Service",
        "title": "UK expert warns of pandemic worse than Covid in new book - The Siasat Daily",
        "description": "The former chair of the UK Vaccine Taskforce Kate Bingham has in a new book warned of a next pandemic that could come from",
        "url": "https://www.siasat.com/uk-expert-warns-of-pandemic-worse-than-covid-in-new-book-2704890/",
        "urlToImage": "https://cdn.siasat.com/wp-content/uploads/2023/09/ascasc-1.jpg",
        "publishedAt": "2023-09-24T13:58:00Z",
        "content": "New Delhi: The former chair of the UK Vaccine Taskforce Kate Bingham has in a new book warned of a next pandemic that could come from a million unknown viruses and kill about 50 million people like t… [+2410 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Gulf News"
        },
        "author": "IANS",
        "title": "Hereditary hair loss in men: Researchers identifies rare gene variants - Gulf News",
        "description": "Male-pattern hair loss is the most common form of hair loss in men",
        "url": "https://gulfnews.com/lifestyle/health-fitness/hereditary-hair-loss-in-men-researchers-identifies-rare-gene-variants-1.1695559206058",
        "urlToImage": "https://imagevars.gulfnews.com/2023/05/22/hair-loss-stock_188439048c3_medium.jpg",
        "publishedAt": "2023-09-24T12:35:43Z",
        "content": "London: Researchers have identified rare gene variants that cause male pattern hair loss, also termed androgenetic alopecia.Male-pattern hair loss is the most common form of hair loss in men, and is … [+3132 chars]"
    },
    {
        "source": {
            "id": "usa-today",
            "name": "USA Today"
        },
        "author": "Ken Alltucker, Eduardo Cuevas",
        "title": "Consumers seeking COVID vaccine face insurance denials, cancellations - USA TODAY",
        "description": "Consumers face roadblocks, denials as federal government shifts COVID-19 vaccinations to private-sector health insurers and clinics. companies,",
        "url": "https://www.usatoday.com/story/news/health/2023/09/23/covid-vaccine-insurance-denials-cancellations/70918394007/",
        "urlToImage": "https://www.usatoday.com/gcdn/presto/2023/01/06/USAT/2b4b3186-c160-4b8f-9413-21cc4e85bbf9-AdobeStock_550239390.jpeg?crop=7925,4457,x0,y0&width=3200&height=1800&format=pjpg&auto=webp",
        "publishedAt": "2023-09-24T12:24:24Z",
        "content": "Some consumers trying to get updated versions of the COVID-19 vaccine this week have encountered red tape, canceled appointments and delays getting private insurance to cover the shots.\r\nThe major sn… [+8060 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Parmita Uniyal",
        "title": "World Heart Day: 10 signs of an unhealthy heart you shouldn't ignore - Hindustan Times",
        "description": "World Heart Day is round the corner and it's the day dedicated to the well-being of your heart. A cardiologist on signs of poor cardiac health. | Health",
        "url": "https://www.hindustantimes.com/lifestyle/health/world-heart-day-10-signs-of-an-unhealthy-heart-you-shouldn-t-ignore-101695555961793.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/world_heart_day_1695556051001_1695556051123.jpg",
        "publishedAt": "2023-09-24T11:53:19Z",
        "content": "World Heart Day is celebrated on September 29 every year. The day aims at spreading awareness around heart conditions and the risk factors that can cause cardiac deaths. Heart is the most important o… [+3641 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Global News"
        },
        "author": "Katie Dangerfield",
        "title": "Get your flu and COVID shots at the same time, health experts urge - Global News",
        "description": "As autumn rolls in, health experts are giving the green light to double up on vaccinations, as getting both the flu and COVID shots can provide an added layer of defense.",
        "url": "https://globalnews.ca/news/9976786/flu-covid-vaccine-same-time/",
        "urlToImage": "https://globalnews.ca/wp-content/uploads/2020/12/CP110211255-2-e1607634052128.jpg?quality=85&strip=all&w=720&h=379&crop=1",
        "publishedAt": "2023-09-24T11:00:35Z",
        "content": "As autumn rolls in, health experts are giving the green light for Canadians to double up on their vaccinations, as getting both the flu and COVID-19 shots at the same time can provide an added layer … [+6373 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Parmita Uniyal",
        "title": "3 diabetes drinks to prevent sugar spikes as per a nutritionist - Hindustan Times",
        "description": "When it comes to managing blood sugar, certain herbs and spices can work wonders. Here are 3 morning drinks to keep glucose levels in check. | Health",
        "url": "https://www.hindustantimes.com/lifestyle/health/3-diabetes-drinks-to-prevent-sugar-spikes-as-per-a-nutritionist-101695542053897.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/cinnamon_tea_1657688898310_1695551565268.jpg",
        "publishedAt": "2023-09-24T10:37:54Z",
        "content": "Diabetes cases have witnessed an exponential rise in the recent decades. Indians are not only more prone to diabetes, but the faulty lifestyle choices also that are increasingly being followed by man… [+2306 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "WION"
        },
        "author": "Kirtika Katira",
        "title": "The Brain-Heart Connection! Experts talk about the connection between Alzheimer`s and Cardiovascular Health - WION",
        "description": "The Brain-Heart Connection! Experts talk about the connection between Alzheimers and Cardiovascular Health",
        "url": "https://www.wionews.com/entertainment/lifestyle/news-the-brain-heart-connection-experts-talk-about-the-connection-between-alzheimers-and-cardiovascular-health-639165",
        "urlToImage": "https://cdn.wionews.com/sites/default/files/2023/09/24/381695-untitled-design-2023-09-24t162342904.jpg",
        "publishedAt": "2023-09-24T10:23:29Z",
        "content": "In the intricate web of human health, a compelling relationship between Alzheimer's disease and cardiovascular health is coming to light, offering new insights into prevention and treatment.\r\nEmergin… [+8630 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Decoding Circadian Diets: Can You Lose Weight On Circadian Fast? | Health 360 | Sneha Mordani - India Today",
        "description": "This week Health 360 is telling you all about our Battle against the Bulge! How is fat loss different from weight loss? How does one identify eating disorder...",
        "url": "https://www.youtube.com/watch?v=Y4oqpYkYAyA",
        "urlToImage": "https://i.ytimg.com/vi/Y4oqpYkYAyA/maxresdefault.jpg",
        "publishedAt": "2023-09-24T10:23:21Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Neurologylive.com"
        },
        "author": "Matt Hoffman",
        "title": "NeurologyLive® Brain Games: September 24, 2023 - Neurology Live",
        "description": "Test your neurology knowledge with NeurologyLive®'s weekly quiz series, featuring questions on a variety of clinical and historical neurology topics. This week's topic is headache and migraine.",
        "url": "https://www.neurologylive.com/view/neurologylive-brain-games-september-24-2023",
        "urlToImage": "https://cdn.sanity.io/images/0vv8moc6/neurolive/2accefc3e108ad7aa14a54f1b916b59d81c52548-1251x1251.png?fit=crop&auto=format",
        "publishedAt": "2023-09-24T10:08:07Z",
        "content": "Welcome to NeurologyLive® Brain Games! This weekly quiz series, which goes live every Sunday morning, will feature questions on a variety of clinical and historical neurology topics, written by physi… [+1432 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Healio"
        },
        "author": null,
        "title": "Prostate Cancer Awareness Month: Financial hardship common, exercise beneficial - Healio",
        "description": "National Prostate Cancer Awareness Month is observed every September.An estimated 288,300 men in the United States will be diagnosed with prostate cancer this year and about 34,700 men will die of the disease, according to American Cancer Society.",
        "url": "https://www.healio.com/news/hematology-oncology/20230920/prostate-cancer-awareness-month-financial-hardship-common-exercise-beneficial",
        "urlToImage": "https://www.healio.com/~/media/slack-news/stock-images/hemonc/p/prostate_cancer_cells.jpeg",
        "publishedAt": "2023-09-24T10:03:09Z",
        "content": "We were unable to process your request. Please try again later. If you continue to have this issue please contact customerservice@slackinc.com.Back to Healio\r\nNational Prostate Cancer Awareness Month… [+2850 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Siasat Daily"
        },
        "author": "Indo-Asian News Service",
        "title": "Ginger supplements can be beneficial in treating autoimmune diseases: Study - The Siasat Daily",
        "description": "Ginger supplements can play an important role in controlling inflammation for people living with autoimmune diseases",
        "url": "https://www.siasat.com/ginger-supplements-can-be-beneficial-in-treating-autoimmune-diseases-study-2704617/",
        "urlToImage": "https://cdn.siasat.com/wp-content/uploads/2023/09/542.jpg",
        "publishedAt": "2023-09-24T09:18:00Z",
        "content": "New York: Ginger supplements can play an important role in controlling inflammation for people living with autoimmune diseases, a new study has found.\r\nResearchers studied the impact of ginger supple… [+2254 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "Smita Mishra",
        "title": "Can Vitamin C serum help reduce wrinkles and pigmentation? - IndiaTimes",
        "description": "Recently, serums have become a new beauty fad-- especially post-pandemic. We spoke to a few dermatologists to understand the need to use Vitamin C ser",
        "url": "https://timesofindia.indiatimes.com/life-style/beauty/can-vitamin-c-serum-help-reduce-wrinkles-and-pigmentation/articleshow/103905730.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103905801,width-1070,height-580,imgsize-40922,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T08:33:00Z",
        "content": "This is why Korean women use sheet masks on their facesKorean women are known for their dedication to skincare, and they have popularized various skincare routines and products around the world. One … [+74 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Thehealthsite.com"
        },
        "author": "Satata Karmakar",
        "title": "Sinus Congestion Home Remedies: Try These 7 Yoga Asanas for Quick Relief | TheHealthSite.com - TheHealthSite",
        "description": "Start with the easier poses such as Child's Pose and Bridge Pose if you are new to yoga. It's critical to pay attention to your body's signals and avoid overexerting yourself. Stop the pose and take a break if you feel any pain.\r\n TheHealthSite.com",
        "url": "https://www.thehealthsite.com/photo-gallery/sinus-congestion-home-remedies-try-these-7-yoga-asanas-for-quick-relief-1013289/",
        "urlToImage": "https://www.thehealthsite.com/wp-content/uploads/2023/09/What-Is-Sinusitis-1.jpg",
        "publishedAt": "2023-09-24T08:31:13Z",
        "content": "TheHealthSite.com is India's fastest growing health information site with a team of health professionals and writers committed to providing unique, authentic, credible, well-researched, and timely in… [+355 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "BBC News"
        },
        "author": "https://www.facebook.com/bbcnews",
        "title": "Devon and Cornwall Police student officers get sensory aids - BBC",
        "description": "New devices are being used by the force to help neurodiverse student police officers.",
        "url": "https://www.bbc.com/news/uk-england-devon-66855354",
        "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/122DB/production/_95695447_middlemoor.jpg",
        "publishedAt": "2023-09-24T08:13:25Z",
        "content": "A sensory learning tool has been introduced to help neurodiverse student police officers in Devon and Cornwall.\r\nThe \"sensory library boards\" are designed to help people with attention deficit hypera… [+1049 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Healthshots.com"
        },
        "author": "Aayushi Gupta",
        "title": "9 nutrients every woman needs to boost longevity - Health shots",
        "description": "Your diet should be rich in several essential nutrients if you wish to stay healthy and live longer. Know 9 important nutrients for women.",
        "url": "https://www.healthshots.com/healthy-eating/nutrition/important-nutrients-for-women/",
        "urlToImage": "https://images.healthshots.com/healthshots/en/uploads/2023/09/22005016/nutrients-for-women.jpg",
        "publishedAt": "2023-09-24T08:00:14Z",
        "content": "Women face several health challenges as they age. From menstruation and pregnancy to breastfeeding and menopause – there’s a lot that their body goes through. On top of it, due to these persistent ch… [+4880 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "ANI",
        "title": "Training gut's immune system to combat effects of emulsifiers in processed foods - Hindustan Times",
        "description": "The study shows how training the gut's immune system can combat harmful repercussions of taking food additive emulsifiers. | Health",
        "url": "https://www.hindustantimes.com/lifestyle/health/training-guts-immune-system-to-combat-detrimental-effects-of-emulsifiers-in-processed-foods-study-101695539682982.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/_3aa8aa6a-b41e-11e8-bb15-a1f88311a832_1695539828847.jpg",
        "publishedAt": "2023-09-24T07:19:38Z",
        "content": "In a new study, mice with immune systems that had been trained against the microbial protein flagellin did not experience the usual harmful repercussions of taking food additive emulsifiers, pointing… [+3022 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Abplive.com"
        },
        "author": "Utsa Ganguly",
        "title": "PCOS Awareness Month 2023: Fertility Challenges For Individuals With PCOS - ABP Live",
        "description": "PCOS has undoubtedly become a major cause of female infertility, decreasing the odds of becoming pregnant naturally and experiencing the joy of motherhood.",
        "url": "https://news.abplive.com/lifestyle/pcos-awareness-month-2023-fertility-challenges-for-individuals-with-pcos-1627811",
        "urlToImage": "https://feeds.abplive.com/onecms/images/uploaded-images/2023/09/24/ac7ca3f8cc5b47ef66d078ba4c3571a51695539676768557_original.png?impolicy=abp_cdn&imwidth=1200&imheight=628",
        "publishedAt": "2023-09-24T07:15:09Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Onmanorama.com"
        },
        "author": "Our Correspondent",
        "title": "Things to note while eating dry fruits every day | Cuisine Corner | Onmanorama - Onmanorama",
        "description": "Fruits would also help reduce body weight if they are eaten in moderate amounts.",
        "url": "https://www.onmanorama.com/food/features/2023/09/24/dry-fruits-right-quantity-healthy-diet.html",
        "urlToImage": "https://img.onmanorama.com/content/dam/mm/en/kerala/images/2021/1/9/dry-fruits-shutterstock.jpg",
        "publishedAt": "2023-09-24T07:11:08Z",
        "content": "Dry fruits are a rich source of nutrients. A large variety of dry fruits is available, including almonds, walnuts, pistachios, figs, raisins and apricots, and all of them have significant amounts of … [+1419 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Harpersbazaar.in"
        },
        "author": "Kristy Carmichael",
        "title": "Could cocoa keep you young? - Harpers Bazaar India",
        "description": "Research has linked the antioxidants found in cocoa with anti-ageing. But can chocolate really keep the years off?",
        "url": "https://www.harpersbazaar.in/beauty/story/could-cocoa-keep-you-young-681820-2023-09-24",
        "urlToImage": "https://akm-img-a-in.tosshub.com/lingo/hrb/images/story/202309/untitled_design_-_2023-09-21t124848.456-sixteen_nine.png",
        "publishedAt": "2023-09-24T06:30:05Z",
        "content": "Chocolate that keeps you young. As health headlines go, this ones up there with margaritas that boost your microbiome and pasta that makes your hair grow. But while we wait patiently for the latter, … [+2818 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India.com"
        },
        "author": "https://www.india.com/author/lifestylestaff/",
        "title": "High Cholesterol: 5 Homemade Drinks You MUST Consume Every Morning to Manage LDL - India.com",
        "description": "High Cholesterol: These nutritious homemade drinks provide the conventional methods for warding off bad cholesterol.",
        "url": "https://www.india.com/health/high-cholesterol-5-homemade-drinks-you-must-consume-every-morning-to-manage-ldl-6350574/",
        "urlToImage": "https://static.india.com/wp-content/uploads/2023/09/Green-Tea-2.jpg",
        "publishedAt": "2023-09-24T06:13:56Z",
        "content": "High Cholesterol: These nutritious homemade drinks provide the conventional methods for warding off bad cholesterol.\r\nHigh Cholesterol: 5 Homemade Drinks You MUST Consume Every Morning to Manage LDL\r… [+2356 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Slurrp.com"
        },
        "author": "Risha Ganguly",
        "title": "Orange To Okra: 8 Calcium Rich Fruits And Veggies For Your Kids' Growth - Slurrp",
        "description": "Adding calcium-rich fruits and vegetables into your child's diet is a delicious and smart way to ensure they get the nutrients necessary for their growth and development. Here are some fruits and veggies that your kids will love.",
        "url": "https://www.slurrp.com/article/orange-to-okra-8-calcium-rich-fruits-and-veggies-for-your-kids-growth-1695534441690",
        "urlToImage": "https://images.slurrp.com/prodarticles/u3zdjt0s0y9.webp",
        "publishedAt": "2023-09-24T06:04:19Z",
        "content": "For all the concerned parents, here are eight such fruits and veggies that will not only support your kids' growth but they will also love to eat them.\r\nOranges:\r\n\" style=\"height: 370px;\"&gt;\r\nRecipe… [+76 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Jagran.com"
        },
        "author": "Prerna Targhotra",
        "title": "8 Foods To Avoid To Prevent Acid Reflux Heartburn - Jagran English",
        "description": "Foods To Avoid For Acid Reflux Although acid reflux can be treated with lifestyle changes one should also be vigilant of the foods they consume to prevent acid reflux Here are some foods that you must avoid to prevent acid reflux and promote healthy digestion",
        "url": "https://english.jagran.com/lifestyle/8-foods-to-avoid-to-prevent-acid-reflux-heartburn-10102651",
        "urlToImage": "https://imgeng.jagran.com/images/2023/sep/foods-to-avoid-for-acid-reflux1695535018727.jpg",
        "publishedAt": "2023-09-24T05:46:00Z",
        "content": "Foods To Avoid For Acid Reflux: GERD or gastroesophageal reflux disease is a health condition that occurs when stomach acid repeatedly flows back into the tube connecting your mouth and stomach. The … [+2747 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "Ash gourd vs bottle gourd, whose juice is better for weight loss - IndiaTimes",
        "description": "When it comes to weight loss, many tend to go for bottle gourd and ash gourd in the form of juices. Both veggies are said to be super healthy and low in calories. Additionally, they are rich in nutrition. Consuming these provides many health benefits. But one…",
        "url": "https://timesofindia.indiatimes.com/life-style/food-news/ash-gourd-vs-bottle-gourd-whose-juice-is-better-for-weight-loss/photostory/103901310.cms",
        "urlToImage": "https://static.toiimg.com/photo/103901323.cms",
        "publishedAt": "2023-09-24T05:30:00Z",
        "content": "Petha is slightly sour-sweet in taste. It is considered quite pure and sweets are also made from it. At the same time, we all consume bottle gourd in many ways. Talking about the juices of both, acco… [+867 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "SciTechDaily"
        },
        "author": null,
        "title": "VIR-1388: Clinical Trial of Preventive HIV Vaccine Begins - SciTechDaily",
        "description": "Novel vaccine includes NIH-funded technology in development since 2004. A trial of a preventive HIV vaccine candidate has begun enrollment in the United States and South Africa. The Phase 1 trial will evaluate a novel vaccine known as VIR-1388 for its safety …",
        "url": "https://scitechdaily.com/?p=311063",
        "urlToImage": "https://scitechdaily.com/images/HIV-1-Virus-Particle.jpg",
        "publishedAt": "2023-09-24T04:46:00Z",
        "content": "ByNational Institutes of Health (NIH)September 23, 2023\r\nColorized transmission electron micrograph of an HIV-1 virus particle (yellow/gold) budding from the plasma membrane of an infected H9 T cell … [+6817 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Dtnext.in"
        },
        "author": "IANS",
        "title": "Man-made plastic chemicals linked to higher postpartum depression: Study - DTNEXT",
        "description": "According to the study published in the JAMA Psychiatry journal, postpartum depression affects up to 20 per cent of new mothers, making it the most common pregnancy complication to occur after...",
        "url": "https://www.dtnext.in/lifestyle/wellbeing/man-made-plastic-chemicals-linked-to-higher-postpartum-depression-study-738067",
        "urlToImage": "https://dtnext-prod.s3.ap-south-1.amazonaws.com/h-upload/2023/09/24/767386-pls.jpg",
        "publishedAt": "2023-09-24T04:34:31Z",
        "content": "NEW YORK: Higher prenatal phthalate levels may increase the risk of postpartum depression, a new study has revealed. \r\nAccording to the study published in the JAMA Psychiatry journal, postpartum depr… [+1614 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Parmita Uniyal",
        "title": "5 ways climbing stairs can improve your heart health - Hindustan Times",
        "description": "Climbing stairs is a heart-healthy exercise as it can not only improve cardiorespiratory fitness but also indicate if anything is wrong with your heart. | Health",
        "url": "https://www.hindustantimes.com/lifestyle/health/5-ways-climbing-stairs-can-improve-your-heart-health-101695528927578.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/climbing_stairs_1695529058876_1695529071907.jpg",
        "publishedAt": "2023-09-24T04:28:16Z",
        "content": "Climbing stairs is one of the most inexpensive, convenient and effective ways to keep fit. It is especially a heart-healthy exercise as it can not only improve cardiorespiratory fitness but can also … [+3427 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Thehealthsite.com"
        },
        "author": "Satata Karmakar",
        "title": "Severe Dengue Fever Management Tips: 6 Ways to Manage Your Symptoms and Recover Quickly | TheHealthSite.co - TheHealthSite",
        "description": "Don't panic if you have a fever. Most fevers are harmless and will go away on their own. However if you have any concerns it's always a good idea to visit a doctor. TheHealthSite.com",
        "url": "https://www.thehealthsite.com/home-remedies/how-to-reduce-fever-at-home-6-tips-for-adults-and-children-for-a-comfortable-recovery-dengue-symptoms-1013211/",
        "urlToImage": "https://st1.thehealthsite.com/wp-content/uploads/2023/09/Fever-3.jpg",
        "publishedAt": "2023-09-24T04:13:00Z",
        "content": "How to Reduce Fever at Home: 6 Tips for Adults and Children For a Comfortable Recovery\r\nDon't panic if you have a fever. Most fevers are harmless and will go away on their own. However, if you have a… [+4625 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India TV News"
        },
        "author": "Edited by Sheenu Sharma",
        "title": "West Bengal: 12-year-old girl tests positive for dengue in Kolkata, dies in hospital - India TV News",
        "description": "Kolkata dengue cases: The girl, identified as Dona Das, a class VII student, was suffering from a high fever for the last seven days, and was taken to the MR Bangur Hospital this morning, an official said.",
        "url": "https://www.indiatvnews.com/west-bengal/kolkata-west-bengal-12-year-old-minor-girl-tests-positive-dengue-kolkata-dies-in-hospital-latest-updates-2023-09-24-894398",
        "urlToImage": "https://resize.indiatvnews.com/en/resize/newbucket/1200_-/2023/09/dengue-1695528339.jpg",
        "publishedAt": "2023-09-24T04:10:46Z",
        "content": "Kolkata dengue cases\r\n: A 12-year-old girl from Kolkata's Jadavpur area, who tested positive for dengue, died at a state-run hospital on Saturday (September 23) afternoon, an official said. The girl,… [+760 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Rising Kashmir Daily English Newspaper"
        },
        "author": "Rising Kashmir",
        "title": "Decoding Gynecologic Cancers: Types, Risk Factors, and Early Detection - Rising Kashmir",
        "description": null,
        "url": "http://risingkashmir.com/decoding-gynecologic-cancers-types-risk-factors-and-early-detection",
        "urlToImage": "http://admin.risingkashmir.com/Source/News/7bea0fc2-76ea-4ffa-961a-987ac9c8f06f.png",
        "publishedAt": "2023-09-24T04:05:55Z",
        "content": "Gynecologic cancers encompass a group of malignancies that affect a woman's reproductive organs, including the cervix, ovaries, uterus, vagina, and vulva. These cancers, although diverse in their ori… [+3280 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Slurrp.com"
        },
        "author": "Niveditha Kalyanaraman",
        "title": "5 Grains To Include In Your Dinner For Weight Loss - Slurrp",
        "description": "5 Grains To Include In Your Dinner For Weight Loss",
        "url": "https://www.slurrp.com/web-stories/5-grains-to-include-in-your-dinner-for-weight-loss/",
        "urlToImage": "https://images.slurrp.com/webstories/wp-content/uploads/2023/09/24092547/cropped-pexels-polina-tankilevitch-4110256-scaled-1.jpg",
        "publishedAt": "2023-09-24T03:55:51Z",
        "content": "The golden rule of weight loss is that you need to eat right and not less. Grains are an excellent way to do that. Low carb grains not only help you in losing weight but will also keep you full for l… [+69 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India.com"
        },
        "author": "https://www.india.com/author/lifestylestaff/",
        "title": "Dengue Cases Rise in India: Can Consuming Goat Milk Increase Platelet Count? Here's The TRUTH - India.com",
        "description": "Dengue cases are increasing nationwide as a result of the recent heavy rains. Patients with dengue believe that consuming goat milk can help boost platelet counts and fight the fever.",
        "url": "https://www.india.com/health/dengue-cases-rise-in-india-can-consuming-goat-milk-increase-platelet-count-heres-the-truth-6350385/",
        "urlToImage": "https://static.india.com/wp-content/uploads/2023/09/Dengue-Fever-2.jpg",
        "publishedAt": "2023-09-24T03:55:24Z",
        "content": "Dengue cases are increasing nationwide as a result of the recent heavy rains. Patients with dengue believe that consuming goat milk can help boost platelet counts and fight the fever.\r\nDengue Cases R… [+2570 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "DNA India"
        },
        "author": "Maitry Kothari",
        "title": "8 foods that may increase your height - DNA India",
        "description": "List of  foods that may increase your height.",
        "url": "https://www.dnaindia.com/web-stories/lifestyle/8-foods-that-may-increase-your-height-1695525708048",
        "urlToImage": null,
        "publishedAt": "2023-09-24T03:42:33Z",
        "content": "Leafy greens provide concentrated amounts of calcium, iron, magnesium, and potassium. Additionally, they contain a lot of vitamin K, which helps encourage improved growth and maintain your height."
    },
    {
        "source": {
            "id": null,
            "name": "Daijiworld.com"
        },
        "author": null,
        "title": "Yemeni govt launches immunisation campaign to prevent measles outbreak - Daijiworld.com",
        "description": "Aden, Sep 24 (IANS): The Yemeni government has launched a national vaccination campaign to immunise more than one million children against measles and rubella, media reported.\r\nYemeni Prime Minister Maeen Abdulmalik officially inaugurated the six-day emergenc…",
        "url": "https://www.daijiworld.com/index.php/news/newsDisplay?newsID=1123544",
        "urlToImage": "https://daijiworld.ap-south-1.linodeobjects.com/Linode/images3/rayan_240923_Middle1.jpg",
        "publishedAt": "2023-09-24T02:50:50Z",
        "content": "Aden, Sep 24 (IANS): The Yemeni government has launched a national vaccination campaign to immunise more than one million children against measles and rubella, media reported.\r\nYemeni Prime Minister … [+1174 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Jagran.com"
        },
        "author": "Aditi Singh",
        "title": "5 High-Protein Breakfast Ideas For Vegetarians - Jagran English",
        "description": "Check out five high-protein vegetarian breakfast ideas to kickstart your morning with energy.",
        "url": "https://english.jagran.com/web-stories/5-high-protein-breakfast-ideas-for-vegetarians-63335",
        "urlToImage": "https://imgeng.jagran.com/webstories/63335/breakfast-1695508811.jpeg",
        "publishedAt": "2023-09-24T02:30:25Z",
        "content": "By Aditi Singh2023-09-24T08:00:25+05:30english.jagran.com \r\nHigh protein breakfast ideas\r\nIf you want to increase your daily protein consumption without adding non-vegetarian food. We got you covered… [+1498 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "The Hindu",
        "title": "New immunology study highlights importance of COVID vaccination of those who have already been exposed to the virus - The Hindu",
        "description": null,
        "url": "https://www.thehindu.com/sci-tech/health/new-immunology-study-highlights-importance-of-covid-vaccination-of-those-who-have-already-been-exposed-to-the-virus/article67334862.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T02:30:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "The Tribune India"
        },
        "author": "The Tribune India",
        "title": "Despite dengue, malaria spread, sanitary conditions, health facilities fail to improve - The Tribune India",
        "description": null,
        "url": "https://www.tribuneindia.com/news/ludhiana/despite-dengue-malaria-spread-sanitary-conditions-health-facilities-fail-to-improve-547260",
        "urlToImage": null,
        "publishedAt": "2023-09-24T02:03:00Z",
        "content": null
    }
]


export default health;